import { render } from "./Permission.vue?vue&type=template&id=89d00dc2&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=89d00dc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-89d00dc2"

export default script